import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from "@core/services/config.service";
import { IdentityStoreService } from "@modules/identity/store/services/identity-store.service";
import { Observable } from "rxjs";
import { UserProfile } from "@modules/identity/models/user";
import { Template } from "@modules/template/student/models/template";
import { TemplateStoreService } from "@modules/template/student/store/services/template-store.service";
import { Location } from "@modules/location/models/location";
import { LocationStoreService } from "@modules/location/store/services/location-store.service";
import { Instructor } from "@modules/instructor/models/instructor";
import { TRANSLATION_SCOPE } from "@modules/template/student/i18n/scope";
import { CourseRequest } from "@modules/template/student/models/course-request";

@Component({
  selector: 'app-template-request',
  templateUrl: './template-request.component.html',
  styleUrls: ['./template-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateRequestComponent implements OnInit {

  translationScope: string = TRANSLATION_SCOPE;
  user$: Observable<UserProfile>;
  templates$: Observable<Template[]>;
  regions$: Observable<Location[]>;
  instructorsByTemplates$: Observable<Instructor[]>;

  constructor(private configService:ConfigService,
              private identityStore:IdentityStoreService,
              private templateStoreService:TemplateStoreService,
              private locationStoreService: LocationStoreService) { }

  get bannerImage() {
    const env = this.configService.getCurrent().env;
    switch (env) {
      case 'production':
        return 'https://rssjoliv-prod.imgix.net/hoyhastighet/hastighetskurs.jpg';
      case 'staging':
        return 'https://rssjoliv-staging.imgix.net/hoyhastighet/hastighetskurs.jpg';
      default:
        return 'https://rssjoliv-dev.imgix.net/hoyhastighet/hastighetskurs.jpg';
    }
  }

  ngOnInit(): void {
    this.user$ = this.identityStore.getUserProfile();
    this.templates$ = this.templateStoreService.getStudentTemplates();
    this.regions$ = this.locationStoreService.getAllLocations();
  }

  requestCourse(courseRequest:CourseRequest) {
    this.templateStoreService.requestClassroomCourse(courseRequest);
  }
}
